export default require("bommediate");


// WEBPACK FOOTER //
// ./src/abusesa-js/time/setImmediate.js